import {ref, Ref} from 'vue'
import {post} from "@/api/phone";
import {FormInline} from "@/components/h_tb_header/tb_header_data";
import {ElLoading} from "element-plus";

interface StatisticResult {
    totalAdd: number;
    totalSef: number;
    totalCal: number;
    monthAdd: number;
    monthSef: number;
    motnCal: number;
    dayAdd: number;
    daySef: number;
    dayCal: number;

    htotalAdd: number;
    htotalSef: number;
    htotalCal: number;
    hmonthAdd: number;
    hmonthSef: number;
    hmotnCal: number;
    hdayAdd: number;
    hdaySef: number;
    hdayCal: number;

    htotalCalLV: number;
    monthAddNotHt: number;
    totalCalNotHt: number;
    dayAddNotHt: number;
    daySefNotHt: number;
    monthSefNotHt: number;
    totalSefNotHt: number;
    dayCalNotHt: number;
    totalAddNotHt: number;
    motnCalNotHt: number;
}

interface SummaryData {
    baoFuAdd: number;
    baoFuCal: number;
    baoFuSelf: number;
    bBaoFuAdd: number;
    bBaoFuCal: number;
    bBaoFuSelf: number;
    huiFuAdd: number;
    huiFuSelf: number;
    huiFuCal: number;
}

export function useCheckPage(
    groupedData: Ref<StatisticResult>,
    summaryData: Ref<SummaryData>,
    hasDateFilter: Ref<boolean>,
    formInline: Ref<FormInline>,
    callback?: () => void
) {

    const onSubmit = async () => {
        try {
            if (formInline.value.date == null) {
                formInline.value.date = ["", ""]
            }

            const loadingInstance = ElLoading.service({fullscreen: true})
            const response = await post<StatisticResult>('/hbank/statistic_oder', {
                ...formInline.value,
            });
            console.log('提交成功:', response.data);

            // 判断是否有日期过滤条件（转换为 boolean 类型）
            const hasFilter = !!(formInline.value.date &&
                formInline.value.date.length === 2 &&
                (formInline.value.date[0] || formInline.value.date[1]));

            // 更新日期过滤标记
            hasDateFilter.value = hasFilter;

            if (!hasFilter) {
                // 无日期时更新 groupedData（基础数据）
                Object.assign(groupedData.value, response.data);
            } else {
                // 有日期时更新 summaryData（查询汇总数据，区分宝付和汇付）
                summaryData.value = {
                    baoFuAdd: response.data.totalAdd || 0,
                    baoFuCal: response.data.totalCal || 0,
                    baoFuSelf: response.data.totalSef || 0,
                    bBaoFuAdd: response.data.totalAddNotHt || 0,
                    bBaoFuCal: response.data.totalCalNotHt || 0,
                    bBaoFuSelf: response.data.totalSefNotHt || 0,
                    huiFuAdd: response.data.htotalAdd || 0,
                    huiFuSelf: response.data.htotalSef || 0,
                    huiFuCal: response.data.htotalCal || 0
                };
            }

            loadingInstance.close();
            callback?.();
        } catch (error) {
            console.error('提交失败:', error);
        }
    };


    return {
        onSubmit
    }
}
